import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import Modal from '../../../common/modal/Modal';
import BaggageCreateCreditNoteForm from './BaggageCreateCreditNoteForm';
import {
  getBaggageV2,
  postGenerateCreditNoteAction,
} from '../../../../actions';
import withEndpointAuthorization from '../../authorization/withEndPointAuthorization';
import { generateBaggageCreditNoteEndpoint } from '../../../../config/endpoints';
import { POST } from '../../../../config/permissions';

const BaggageCreditNoteButton = ({
  baggage,
  dispatchPostGenerateCreditNote,
  dispatchGetBaggageV2,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [bodyModal, setBodyModal] = useState(null);
  const [titleModal, setTitleModal] = useState('');

  const onSubmit = async (formValues) => {
    const { creditNoteMotive, creditNoteMotiveDescription } = formValues;

    const payload = {
      creditNoteMotive: creditNoteMotive.value,
      baggageId: baggage.id,
      creditNoteMotiveDescription,
      excessBaggageId: baggage.excessBaggage.id,
    };

    await dispatchPostGenerateCreditNote({ ...payload });
    await dispatchGetBaggageV2({ id: baggage.id });
  };

  const openModal = () => {
    setShowModal(true);
    const body = (
      <BaggageCreateCreditNoteForm baggage={baggage} onSubmit={onSubmit} />
    );
    setBodyModal(body);
    setTitleModal('Crear Nota de Crédito');
  };

  const closeModal = () => {
    setShowModal(false);
    setBodyModal(null);
    setTitleModal('');
  };

  return (
    <>
      <Modal
        title={titleModal}
        show={showModal}
        onClickClose={closeModal}
        onClickCancel={closeModal}
        body={bodyModal}
      />
      <Button color="info" onClick={openModal}>
        <i className="fa fa-file-text" /> Nota de crédito
      </Button>
    </>
  );
};

BaggageCreditNoteButton.propTypes = {
  baggage: PropTypes.shape({
    id: PropTypes.number,
    excessBaggage: PropTypes.shape({
      id: PropTypes.number,
    }),
  }),
  dispatchPostGenerateCreditNote: PropTypes.func.isRequired,
  dispatchGetBaggageV2: PropTypes.func.isRequired,
};

BaggageCreditNoteButton.defaultProps = {
  baggage: null,
};

const mapDispatchToProps = {
  dispatchPostGenerateCreditNote: postGenerateCreditNoteAction,
  dispatchGetBaggageV2: getBaggageV2,
};

const connectedComponent = connect(
  null,
  mapDispatchToProps,
)(BaggageCreditNoteButton);

export default withEndpointAuthorization({
  url: generateBaggageCreditNoteEndpoint(0),
  permissionType: POST,
})(connectedComponent);
